/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListEscalatedActionsRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {ListEscalatedActionsResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const listEscalatedActions = (request:ListEscalatedActionsRequest, options?: CashRequestOptions) => post<ListEscalatedActionsRequest, ListEscalatedActionsResponse>("/2.0/cash/list-escalated-actions", request, {...options, rejectOnError: true })